import { connect } from 'react-redux'

import moment from 'moment'
import { saveMetadata } from './metadata.actions'
import MetadataEditor, { UnstyledMetadataEditor } from './MetadataEditor'
import { METADATA_TYPE } from './metadata.constants'

const mapStateToProps = ({ media: { metadata } }) => ({
  loading: metadata.loading,
  error: metadata.error,
})

const mapDispatchToProps = (dispatch, { contact: { id, metadata, goal } }) => ({
  async handleSubmission(metadataKv) {
    const goalId = goal !== null ? goal.id : null
    const metadataSubmission = Object.keys(metadataKv).reduce((submission, key) => {
      const oldMetadata = metadata[key]
      const rawValue = metadataKv[key]

      let value = null

      //Format date if needed
      if (rawValue !== '' && rawValue !== null) {
        value = oldMetadata.type === METADATA_TYPE.DATE ? moment(rawValue).format('YYYY-MM-DD') : rawValue + ''
      }

      //Add to submission if it differs from the old metadata
      if (value !== oldMetadata.value) {
        submission[key] = { key, value }
      }

      return submission
    }, {})

    const metadataResults = dispatch(saveMetadata(['recording', id, goalId, metadataSubmission]))
    await metadataResults
  },
})

export { UnstyledMetadataEditor }

export default connect(mapStateToProps, mapDispatchToProps)(MetadataEditor)
